import { jsonProperty, Serializable, SerializationSettings } from 'ts-serializable';

interface IComponentCorrespondentImagemAlternativas {
    codigo: number;
    filepath: string;
    matchText: string;
    ordemFilepath: number;
    ordemMatch: number;
    base64: string;
}

class ComponentCorrespondentImagemAlternativas extends Serializable {
    @jsonProperty(Number)
    codigo: number = -1;

    @jsonProperty(String)
    filepath: string = '';

    @jsonProperty(String)
    matchText: string = '';

    @jsonProperty(Number)
    ordemFilepath: number = -1;

    @jsonProperty(Number)
    ordemMatch: number = -1;

    @jsonProperty(String)
    base64: string = '';

    fromJSON(json: IComponentCorrespondentImagemAlternativas, settings?: Partial<SerializationSettings>): this {
        this.codigo = json.codigo;
        this.filepath = json.filepath;
        this.matchText = json.matchText;
        this.ordemFilepath = json.ordemFilepath;
        this.ordemMatch = json.ordemMatch;
        this.base64 = json.base64;
        return this;
    }
}

export default ComponentCorrespondentImagemAlternativas;
